export { default as afterConferenceConfig } from './afterConference'
export { default as arcSymposiumConfig } from './arcSymposium'
export { default as conferenceConfig } from './conference'
export { default as countdownConfig } from './countdown'
export { default as registrationConfig } from './registration'
export { default as callForContentConfig } from './callForContent'
export { default as discoveryDayConfig } from './discoveryDay'

export const EXPERIENCE = {
  ANNOUNCE: 'announce',
  REGISTRATION: 'registration',
  COUNTDOWN: 'countdown',
  CONFERENCE: 'conference',
  AFTER_CONFERENCE: 'afterConference',
}
